module.exports = "/static/assets/f64590d85fc77d74e5b1e9171726bda7.png";